import { render } from "./QrReader.vue?vue&type=template&id=64e00849&scoped=true"
import script from "./QrReader.vue?vue&type=script&lang=js"
export * from "./QrReader.vue?vue&type=script&lang=js"

import "./QrReader.vue?vue&type=style&index=0&id=64e00849&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64e00849"]])

export default __exports__